// The theme has no 700px breakpoint (xs:0 / sm:600 / md:960 / lg:1280 / xl:1920)
// and the project page treats <700px as "phone". Keep the raw media query so a
// phone value can be set without disturbing anything at 700px and up - place the
// block last in an `sx` object so it wins over the breakpoint values above it.
export const MOBILE = '@media (max-width:699.95px)';

// The preview tile on a table row. Big enough to recognise a shot at a glance,
// small enough that the row stays a row; 16:9 is applied to these widths.
export const ROW_THUMB_WIDTH = { xs: '54px', sm: '62px', md: '72px', lg: '88px', xl: '118px' };

// Phones have no hover, so the tile is sized to the one narrow column there.
export const ROW_THUMB_WIDTH_MOBILE = '68px';

// How far the tile grows under the pointer. The enlarged copy is portalled out
// of the list's scroll box, so nothing clips it - the size here is a judgement
// about how much of the row it should cover, not a limit imposed by the layout.
// The bounds keep it readable on a small screen without it dominating a large
// one; the tile's own aspect ratio is preserved either way.
export const ROW_THUMB_HOVER_SCALE = 2;
export const ROW_THUMB_HOVER_MIN_WIDTH = 150;
export const ROW_THUMB_HOVER_MAX_WIDTH = 260;

// The quick preview's stage is this shape for every file - the media inside is
// fitted to it, so the dialog never resizes to the file.
export const PREVIEW_STAGE_ASPECT = '16 / 9';
